import React from "react";
import { Col, Container } from 'react-bootstrap';
import { SvgIcon } from "@mui/material";

import TypeOfPolicyIcon from '../../../icons/typeOfPolicy.svg?react';
import DeathBenefitIcon from '../../../icons/deathBenefit.svg?react'
import InsuranceCarrierIcon from '../../../icons/insuranceCarrier.svg?react';
import DateIssuedIcon from '../../../icons/dateIssued.svg?react';
import PolicyBeneficiariesIcon from '../../../icons/policyBeneficiaries.svg?react';

import './Marketing.scss';

export default function Marketing() {

  return (
    <div className="marketing-wrapper background-color-16">
      <Container className="marketing-container d-flex justify-content-center">
        <Col lg={7}>
          <h3 className="title">We can help you review your insurance policy</h3>
          <p className="content">Our licensed insurance specialists are available to meet with you over the phone to discuss your current coverage and to review any possible changes or gaps that may exist. We are prepared to review each aspect of your coverage including:</p>
          <ul>
            <li className="d-flex">
              <div className="icon-container">
                <div className="icon">
                  <SvgIcon component={TypeOfPolicyIcon} color='primary' />
                </div>
              </div>
              <div className="content-container">
                <h4>Type of policy</h4>
                <p>Determine if the type of policy you have—whether it's term or permanent—fits your current needs.</p>
              </div>
            </li>
            <li className="d-flex">
              <div className="icon-container">
                <div className="icon">
                  <SvgIcon component={DeathBenefitIcon} color='primary' />
                </div>
              </div>
              <div className="content-container">
                <h4>Death benefit</h4>
                <p>Look over the coverage amount you originally purchased. Do you have the right benefit amount for your family’s current needs?</p>
              </div>
            </li>
            <li className="d-flex">
              <div className="icon-container">
                <div className="icon">
                  <SvgIcon component={InsuranceCarrierIcon} color='primary' />
                </div>
              </div>
              <div className="content-container">
                <h4>Insurance carrier</h4>
                <p>Review your insurance carrier and keep track of the contact information. Having this information easily available can be helpful for your family.</p>
              </div>
            </li>
            <li className="d-flex">
              <div className="icon-container">
                <div className="icon">
                  <SvgIcon component={DateIssuedIcon} color='primary' />
                </div>
              </div>
              <div className="content-container">
                <h4>Date issued</h4>
                <p>If you have term life insurance, set a reminder to review your policy before its end date.</p>
              </div>
            </li>
            <li className="d-flex">
              <div className="icon-container">
                <div className="icon">
                  <SvgIcon component={PolicyBeneficiariesIcon} color='primary' />
                </div>
              </div>
              <div className="content-container">
                <h4>Beneficiaries</h4>
                <p>It's critical to check that your beneficiaries continue to reflect your intentions.</p>
              </div>
            </li>
          </ul>
        </Col>
      </Container>
    </div>
  );
}
